import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const ModalContent = styled('div')(`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow: hidden;
    background-color: ${colors.white};
    border-radius: 8px;
    border: 1px solid ${colors.primary500};
    padding: 32px;
    margin: auto;
    box-shadow: 0px 7px 14px 0px #053A6812, 0px 7px 7px 0px #053A6826;

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      margin-bottom: 4px;
    }
  `);

export const CustomModalRoot = styled('div')`
  position: fixed;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;
